const workerUrl = 'https://api-vionic-blogs.ropstdigitall.workers.dev';
  const token = '5117dbc4cf6bb3ae8161a6cb9a944e9e3bf924d5a935fdcf65695a5452116e88';

  let allBlogs = [];
  let allArticlesByBlog = [];

  let currentFilters = {
    blogSearch: '',
    selectedBlogs: []
  }

  const itemsPerPage = document.getElementById('itemsPerPage').value;

  // === Cargar todos los artículos al inicio ===
  async function loadAllArticles() {
    try {
      const response = await fetch(`${workerUrl}/all-articles`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error('Error fetching articles');

      const data = await response.json();
      allArticlesByBlog = data.blogs;

      const allArticles = allArticlesByBlog.flatMap(b => b.articles)
      paginateArticles(allArticles, itemsPerPage, '.pagination');
    } catch (error) {
      console.error('Error:', error.message);
      document.getElementById('articlesList').innerHTML = `<p>Error fetching articles</p>`;
    }
  }

  // === Renderizar todos los artículos ===
  function renderArticles(articles) {
    const container = document.getElementById('articlesList');
    container.innerHTML = '';

    if (!articles.length) {
      container.innerHTML = '<p>No articles found</p>';
      return;
    }

    articles.forEach((article) => {
      if (!articles || !articles.length) return;

      const item = document.createElement('div');
        item.className = 'article-item';
        item.innerHTML = `
          <div class="all-articles-content">
            <h3 class="all-articles-title" data-article-id="${article.id}">${article.title}</h3>
            <div class=all-articles-posted-tags>
              <span class="all-articles-posted">Posted on: ${new Date(article.published_at).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}</span>
              <p class="all-articles-tags">${article.tags}</p>
            </div>
          </div>
          <img class="all-articles-image" data-article-id="${article.id}" src="${article.image.src}" width="${article.image.width}" height="${article.image.height}" loading="lazy">
        `;
        container.appendChild(item);
        selectedArticle(article);
    });
  }

  // === Cargar solo blogs (para buscar por título de blog) ===
  async function loadAllBlogs() {
    try {
      const res = await fetch(`${workerUrl}/blogs`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) throw new Error('Error fetching blogs');
      const data = await res.json();
      allBlogs = data.blogs;

      checkboxFilter(allBlogs);

    } catch (error) {
      console.error('Error getting blogs:', error.message);
    }
  }

  function applyFilters() {

    const articlesList = document.querySelector('.right-panel');
    const isSingleArticleView = articlesList.classList.contains('single-article-view');
    if (isSingleArticleView) {
      exitArticleViewWithFilters();
      return;
    }

    let filteredArticles = [...allArticlesByBlog];

    if (currentFilters.selectedBlogs.length > 0) {
      filteredArticles = filteredArticles.filter(blog => 
        currentFilters.selectedBlogs.includes(blog.blog_id.toString())
      );
    }

    if (currentFilters.blogSearch) {
      const matchingBlogs = allBlogs.filter(blog => 
        blog.title.toLowerCase().includes(currentFilters.blogSearch)
      );
      filteredArticles = filteredArticles.filter(blog =>
        matchingBlogs.some(b => b.id === blog.blog_id)
      );
    }

    let articles = filteredArticles.flatMap(blog => blog.articles || []);
    
    paginateArticles(articles, itemsPerPage, '.pagination');
  }

  // === Evento: Filtrar blogs por nombre ===
  document.getElementById('blogSearch').addEventListener('input', (e) => {
    currentFilters.blogSearch = e.target.value.toLowerCase();
    applyFilters();
  });

  function selectedArticle(article) {
    const buttons = document.querySelectorAll(`[data-article-id="${article.id}"]`);
    buttons.forEach(button => {

      button.addEventListener('click', async () => {
  
        const articlesList = document.querySelector('.right-panel');
        articlesList.classList.add('single-article-view');
  
        try {
          const singleArticle = await fetch(`${workerUrl}/articles?blog_id=${article.blog_id}&article_id=${article.id}`, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          const data = await singleArticle.json();
        
          const renderArticleBody = data.article.body_html;
          const formattedDate = new Date(data.article.published_at).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          });
          const articleContainer = document.getElementById('articlesContainer');
          articleContainer.innerHTML = `
            <button id="returnToBlogs">
              <svg class="return-icon" xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
                <path d="M11.1691 19.0426C11.1739 18.0842 10.2343 16.6483 9.28188 15.4423C8.05738 13.8862 6.59165 12.5265 4.90862 11.486C3.64666 10.706 2.11589 9.95564 0.88107 9.94947M0.88107 9.94947C2.11589 9.95564 3.65537 9.2206 4.92376 8.45322C6.6171 7.42832 8.09633 6.08332 9.33629 4.54207C10.3007 3.34433 11.2546 1.91532 11.2594 0.959499M0.88107 9.94947L21.1235 10.0505" stroke="#414042"/>
              </svg>
              Return to blogs
            </button>
            <article class="article-container">
              <header class="article-header">
                <h2 class="single-article-title">${data.article.title}</h2>
                <div>
                  <strong>Posted ${formattedDate}</strong>
                  <p>${data.article.tags}</p>
                </div>
              </header>
              <img class="single-article-image" src="${data.article.image.src}" width="${data.article.image.width}" height="${data.article.image.height}" alt="${data.article.title}" loading="lazy">
              <div class="article-body">${renderArticleBody}</div>
            </article>
          `;
  
          document.getElementById('returnToBlogs').addEventListener('click', () => {
            exitArticleViewWithFilters();
          });
  
          const singleArticleImage = document.querySelectorAll('.single-article-image');
  
          if (window.innerWidth >= 1024) {
            singleArticleImage.forEach(image => {
              const widthAttr = image.getAttribute('width');
              const heightAttr = image.getAttribute('height');
  
              image.style.width = widthAttr ? `${widthAttr}px` : '100%';
              image.style.height = heightAttr ? `${heightAttr}px` : 'auto';
            })
        
          }
        } catch (error) {
          console.error('Error fetching article:', error.message);
        }
      });
    })
  }

  //Pagination
  function paginateArticles(articles, itemsPerPage, paginationContainer) {
    let currentPage = 1;
    const totalPages = Math.ceil(articles.length / itemsPerPage);

    function showItems (page) {
      const start = (page - 1) * itemsPerPage;
      const end = start + itemsPerPage;
      // const itemsToShow = articles.slice(start, end);

      renderArticles(articles.slice(start, end));

      // renderArticles(itemsToShow);
    }

    function renderPagination() {
      const pagination = document.querySelector(paginationContainer);
      pagination.innerHTML = '';

      for (let i = 1; i <= totalPages; i++) {
        const pageLink = document.createElement('button');
        pageLink.className = 'page-link';
        pageLink.innerText = i;

        if ( i === currentPage) {
          pageLink.classList.add('active');
        }

        pageLink.addEventListener('click', (event)=> {
          event.preventDefault();
          currentPage = i;
          showItems(currentPage);

          const currentActive = pagination.querySelector('.active');
          currentActive.classList.remove('active');
          pageLink.classList.add('active');
        })

        pagination.appendChild(pageLink);
      }
    }

    showItems(currentPage);
    renderPagination();
  }

  function checkboxFilter(blogs) {
    const container = document.querySelector('.checkbox-filter-container');
    container.innerHTML = '';
    
    blogs.forEach(blog => {
      const checkbox = document.createElement('input');
      checkbox.className = 'blog-checkbox';
      checkbox.type = 'checkbox';
      checkbox.id = `blog-${blog.id}`;
      checkbox.value = blog.id;

      const label = document.createElement('label');
      label.className = 'blog-label';
      label.htmlFor = `blog-${blog.id}`;
      label.innerText = blog.title;

      checkbox.addEventListener('change', () => {
        currentFilters.selectedBlogs = Array.from(
          document.querySelectorAll('.checkbox-filter-container input:checked')
        ).map(input => input.value);

        applyFilters();
      });

      container.appendChild(checkbox);
      container.appendChild(label);
    });
  }

  function exitArticleViewWithFilters() {
    const articlesList = document.querySelector('.right-panel');
    articlesList.classList.remove('single-article-view');
    document.getElementById('articlesContainer').innerHTML = `
      <div id="articlesList"></div>
      <div class="pagination"></div>
    `;
    applyFilters();
  }
  
  // === Iniciar aplicación ===
  loadAllBlogs();
  loadAllArticles();